export default __webpack_public_path__ + "static/media/jr-logo.79135aef.png";